/* eslint-disable */
export default {
  hide: '숨기기',
  end: '종료',
  keypad: '키패드',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
